module.exports = __webpack_public_path__ + "img/text-classify9.933dcf95.png";